module.exports = __webpack_public_path__ + "img/shape.7948cb7b.svg";